import React from 'react';
import { ApolloProvider, gql, useQuery, useMutation } from '@apollo/client';
import client from '../lib/apolloClient';
import PersonaWizard from '../components/Succeedo/Onboarding/PersonaWizard';

const GET_CURRENT_USER_ONBOARDING = gql`
  query GetCurrentUserOnboarding {
    currentUser {
      id
      succeedo_persona
      succeedo_goal
      time_horizon
      role_title
      succeedo_company_name
      province
      industry_sector
      industry_description
      owner_role
      business_size_band
      sale_objective
      desired_timeline
      business_name_confidential
      buyer_profile
    }
  }
`;

const SAVE_SUCCEEDO_ONBOARDING = gql`
  mutation SaveSucceedoOnboarding(
    $persona: String!
    $goal: String!
    $timeHorizon: String
    $roleTitle: String
    $companyName: String
    $geography: String
    $ownerRole: String
    $industrySector: String
    $industryDescription: String
    $businessSizeBand: String
    $saleObjective: String
    $desiredTimeline: String
    $businessNameConfidential: Boolean
    $buyerType: String
    $acquisitionIntent: String
    $preferredIndustries: [String!]
    $targetGeography: String
    $targetSizeRange: String
    $dealRole: String
    $budgetRange: String
  ) {
    save_succeedo_onboarding(
      persona: $persona
      goal: $goal
      time_horizon: $timeHorizon
      role_title: $roleTitle
      company_name: $companyName
      geography: $geography
      owner_role: $ownerRole
      industry_sector: $industrySector
      industry_description: $industryDescription
      business_size_band: $businessSizeBand
      sale_objective: $saleObjective
      desired_timeline: $desiredTimeline
      business_name_confidential: $businessNameConfidential
      buyer_type: $buyerType
      acquisition_intent: $acquisitionIntent
      preferred_industries: $preferredIndustries
      target_geography: $targetGeography
      target_size_range: $targetSizeRange
      deal_role: $dealRole
      budget_range: $budgetRange
    ) {
      user {
        id
        succeedo_persona
        succeedo_goal
      }
      errors
    }
  }
`;

function PersonaWizardWithData() {
  const { data, loading: queryLoading } = useQuery(GET_CURRENT_USER_ONBOARDING);
  const [saveOnboarding, { loading: mutationLoading }] = useMutation(SAVE_SUCCEEDO_ONBOARDING);

  const currentUser = data?.currentUser || null;

  const handleSave = async (variables) => {
    const { data: result } = await saveOnboarding({ variables });
    if (result?.save_succeedo_onboarding?.errors?.length > 0) {
      throw new Error(result.save_succeedo_onboarding.errors.join(', '));
    }
    return result;
  };

  if (queryLoading) {
    return (
      <div className="dark min-h-screen bg-[hsl(var(--background))] flex items-center justify-center p-4">
        <div className="bg-white rounded-[16px] p-8 max-w-[600px] w-full shadow-2xl text-center">
          <div className="text-[#737373] text-[16px]">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <PersonaWizard
      currentUser={currentUser}
      onSave={handleSave}
      loading={mutationLoading}
    />
  );
}

const SucceedoPersonaWizardContainer = (_props, _railsContext) => (
  <ApolloProvider client={client}>
    <PersonaWizardWithData />
  </ApolloProvider>
);

export default SucceedoPersonaWizardContainer;
